/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_ExitInputs */

const vi_impersonation_exit = /** @type {(inputs: Impersonation_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thoát`)
};

/**

* @param {Impersonation_ExitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_exit = /** @type {((inputs?: Impersonation_ExitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_ExitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_exit(inputs)
});